export class AssetResponse {
  id: number;
  mediaId: string;
  filename: string;
  originalFilename: string;
  entityName: string;
  mimeType: string;
  size: number;
  alt: null;
  mode: string;
  createdAt: string;
  lastModifiedAt: string;
  createdBy: string;
  lastModifiedBy: string;
  downloadUrl: string;
  showUrl: string;

  private constructor() {}
  static from(source: Partial<AssetResponse>) {
    return new AssetResponse().deserialize(source);
  }

  private deserialize(data: Partial<AssetResponse>) {
    Object.assign(this, data);
    return this;
  }
}
